module.exports = __webpack_public_path__ + "img/MaidAufDemFelsen.0296345b.jpg";